import AccessoryCategoryManagementComponent from 'components/desktop/StandingData/AccessoryCategory/Management/AccessoryCategoryManagementComponent';

const AccessoryCategoryManagementContainer = () => {
	const renderContent = () => {
		return (
			<main className="container">
				<AccessoryCategoryManagementComponent />
			</main>
		);
	};

	return <>{renderContent()}</>;
};

export default AccessoryCategoryManagementContainer;
